import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { VmsEffects } from './vms.effects';
import { StoreModule } from '@ngrx/store';
import * as fromVMSState from './vms.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromVMSState.vmsFeatureKey, fromVMSState.reducer),
    EffectsModule.forFeature([VmsEffects]),
  ],
})
export class VmsModule {}
